<template>
  <div>
    <v-list two-line subheader >
      <v-subheader v-if="title">{{title}}</v-subheader>
      <template v-for="detail in selectedTournee">
        <v-list-tile
          :key="`ordre-${detail.id}`"
          ripple
          >
          <v-list-tile-avatar>
            <v-checkbox :input-value="detail.eleveurChecked" @change="updateChecked(detail.id,$event)"></v-checkbox>
          </v-list-tile-avatar>
          <v-list-tile-content @click="eleveurSelectionned = detail;voirDetails = !voirDetails" style="cursor: pointer;">
            <v-list-tile-title>
              {{detail.nom}}
            </v-list-tile-title>
            <v-list-tile-sub-title>
              {{detail.adresse}}
            </v-list-tile-sub-title>
          </v-list-tile-content>
          <v-list-tile-avatar>
            <v-btn 
              icon
              color="primary"
              :href="`https://www.google.com/maps/dir/?api=1&destination=${detail.latitude},${detail.longitude}`"
              target="_blank">
              <v-icon>directions</v-icon>
            </v-btn>
          </v-list-tile-avatar>
        </v-list-tile>
      </template>
      <slot name="no-data" v-if="!selectedTournee.length"></slot>
    </v-list>

    <!-- Voir le détail de l'éleveur-->
    <v-dialog v-model="voirDetails" max-width="700" no-click-animation>
      <v-card>
        <v-card-title class="headline">
          Detail de l'éleveur
        </v-card-title>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs4>Tiers</v-flex>
            <v-flex xs8 class="font-weight-medium">{{eleveurSelectionned.tiers}}</v-flex>
            <v-flex xs4>Nom</v-flex>
            <v-flex xs8 class="font-weight-medium">{{eleveurSelectionned.nom}}</v-flex>
            <v-flex xs4>Adresse</v-flex>
            <v-flex xs8 class="font-weight-medium">{{eleveurSelectionned.adresse}}</v-flex>
            <v-flex xs4>Latitude</v-flex>
            <v-flex xs8 class="font-weight-medium">{{eleveurSelectionned.latitude}}</v-flex>
            <v-flex xs4>Longitude</v-flex>
            <v-flex xs8 class="font-weight-medium">{{eleveurSelectionned.longitude}}</v-flex>
            <v-flex xs4>Commentaire</v-flex>
            <v-flex xs8 class="font-weight-medium">{{eleveurSelectionned.commentaire}}</v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            flat="flat"
            @click="voirDetails = !voirDetails">
            Fermer
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import { CHECK_ELEVEUR_MUTATION } from '@/store'

export default {
  props: {
    idTournee: Number,
    voirChecked: Boolean,
    title: String,
  },
  data: () => ({
    voirDetails: false,
    eleveurSelectionned: {}
  }),
  computed: {
    selectedTournee(){
      const { details } = this.$store.getters.selectedTournee(this.idTournee) || []
      return details.filter(e=>e.eleveurChecked == this.voirChecked)
    },
  },
  methods: {
    updateChecked(idEleveur,event){
      // appelle de la mutation
      this.checkEleveur({ idTournee : this.idTournee,idEleveur,checked: event})
    },
    ...mapMutations({
      checkEleveur : CHECK_ELEVEUR_MUTATION
    })
  }
}
</script>